import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { VisaInfoService } from '@univacity/angular/datas';
import { VisaInfo } from '@univacity/shared/types';

export const visaInfoResolver: ResolveFn<VisaInfo | undefined> = (
  route: ActivatedRouteSnapshot
) => {
  const { from, to } = route.queryParams;
  return inject(VisaInfoService).findOnByCode(from, to);
};
